import { render, staticRenderFns } from "./YzBadge.vue?vue&type=template&id=1fd0dfca&scoped=true&lang=pug&"
import script from "./YzBadge.vue?vue&type=script&lang=js&"
export * from "./YzBadge.vue?vue&type=script&lang=js&"
import style0 from "./YzBadge.vue?vue&type=style&index=0&id=1fd0dfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd0dfca",
  null
  
)

export default component.exports